module.exports = __webpack_public_path__ + "assets/img/8311e2b766d969563e07716d7f285da8.png";